module.exports = __webpack_public_path__ + "static/media/cab-q48.fb9cec92.jpg";